var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2_00000124883420236058559830000005400277047302399368_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1162.9 267",
    style: {
      enableBackground: "new 0 0 1162.9 267"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1C1B1A;}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{fill:#00C098;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1018.8,21.1C1004.5,7.7,984.9,0,964.9,0S925.3,7.7,911,21.1c-13.6,12.8-21.8,29.7-23.9,49.4h-43.9v22h44 c5.3,45.7,42.5,70.2,77.8,70.2c20,0,39.6-7.7,53.9-21.2c11.2-10.5,24.5-29.5,24.5-60.2C1043.3,56.9,1034.8,36.1,1018.8,21.1 L1018.8,21.1z M964.9,137.9c-30.7,0-46.9-21.9-50.8-45.6h34.9c-5.8,7.8-7.1,15.8-7.1,21.3v2.7h22.2v-2.7c0-6.1,4.3-11.5,12.8-15.8 c6.5-3.4,13.6-4.8,15.4-5.1c2.2-0.3,4.2-0.4,4.2-0.4v-22c0,0-1.5,0-3.8-0.3c-3-0.4-28.6-6.1-28.6-21.1v-2.7H942V49 c0,5.5,1.3,13.5,7.2,21.4h-35.1c3.7-23.7,20-45.8,50.8-45.8c35.5,0,51.7,29.3,51.7,56.6S1000.4,138,964.9,137.9L964.9,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.1,5.3H0v152.5h23.3V96.5H56c28.1,0,47.8-18.7,47.8-45.5S83.7,5.3,56.1,5.3z M52.2,75.4h-29v-49h29 c17.2,0,27.9,9.5,27.9,24.8S69.4,75.4,52.2,75.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "118.9,157.8 185.9,157.8 185.9,133.8 143,133.8 143,92 180.4,92 180.4,69.3 143,69.3 143,27.5  185.9,27.5 185.9,4.7 118.9,4.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.1,51.2c0-27-19.5-45.9-47.4-45.9h-58v152.5h23.5V96.5h20.6l34.4,61.4h27l-36.1-63.2 C298.4,89.8,312.1,73.3,312.1,51.2L312.1,51.2z M230.3,75.4v-49h30.7c16.6,0,27.3,9.7,27.3,24.8s-10.7,24.2-27.3,24.2H230.3 L230.3,75.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "377.7,82.6 350.5,4.7 327.6,4.7 327.6,157.8 351.7,157.8 351.7,71.3 371.3,131 383.9,131 403.7,71.3  403.7,157.8 427.8,157.8 427.8,4.7 404.7,4.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "449,157.8 543,157.8 543,136.1 472.2,136.1 472.2,92.7 536.4,92.7 536.4,70.7 472.2,70.7 472.2,27  543,27 543,5.3 449,5.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M742.3,71.7l-22.5-4.9c-11.7-2.5-18.4-10.1-18.4-20.7c0-13.6,12-23.9,27.9-23.9c21.2,0,29.2,15.5,30.7,24.7 l0.2,1.5l21.1-7.4l-0.2-1c-1.9-9-11.2-38.4-52.2-38.4c-27.6,0-51,21.1-51,46.1c0,21.4,14.1,37.3,37.7,42.4l21.5,4.7 c13.5,2.8,21.6,11.2,21.6,22.2c0,14.1-11.4,22.8-29.8,22.8c-23.7,0-33.6-16.8-34.9-31.2l-0.1-1.5l-22.4,7.2l0.1,1 c2.7,21.2,19.4,45.9,57.5,45.9c30.4,0,53.3-19.7,53.3-45.9C782.4,93.2,767.8,77.3,742.3,71.7L742.3,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M621.6,71.7L599,66.8c-11.7-2.5-18.4-10.1-18.4-20.7c0-13.6,12-23.9,27.9-23.9c21.2,0,29.2,15.5,30.7,24.7 l0.2,1.5l21.1-7.4l-0.2-1c-1.9-9-11.2-38.4-52.2-38.4c-27.6,0-51,21.1-51,46.1c0,21.4,14.1,37.3,37.7,42.4l21.5,4.7 c13.5,2.8,21.6,11.2,21.6,22.2c0,14.1-11.4,22.8-29.8,22.8c-23.7,0-33.6-16.8-34.9-31.2l-0.1-1.5l-22.4,7.2l0.1,1 c2.7,21.2,19.4,45.9,57.5,45.9c30.4,0,53.3-19.7,53.3-45.9C661.6,93.2,647,77.3,621.6,71.7L621.6,71.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 798,
    y: 4.7,
    className: "st0",
    width: 23.7,
    height: 153.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1109.4,66 1140.3,2.5 1112.5,2.5 1084.9,62.7 1084.9,2.5 1057.7,2.5 1057.7,159.4 1084.9,159.4  1084.9,112 1093.4,96.1 1116.6,159.4 1145.4,159.4  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.5,188.1v58.4H4.2v-58.4H12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.9,188.1v50h16.6v8.4H39.5v-58.4H47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.4,188.1v7.9h-9.7v50.5h-8.4V196h-9.7v-7.9H146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.3,188.1v44.6c0,3.7,2.1,5.9,5.2,5.9c3.1,0,5.2-2.2,5.2-5.9v-44.6h8.4v45.5c0,7.4-6.1,13.4-13.5,13.4 c-7.2,0-13.5-6-13.5-13.4v-45.4H177.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.3,233c0,8-6.2,13.9-14,13.9c-7.7,0-14-5.7-14-13.9v-31.5c0-8.1,6.2-13.9,14-13.9c7.7,0,14,5.7,14,13.9 V233z M230.6,232.9c0,3.6,2.5,5.7,5.7,5.7c3.2,0,5.7-2.1,5.7-5.7v-31.2c0-3.6-2.5-5.7-5.7-5.7c-3,0-5.6,2.1-5.6,5.7V232.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M335.5,188.1v7.9H319v17.1h14.4v7.9H319v17.1h16.6v8.4h-24.9v-58.4H335.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M365.8,188.1l6.6,40.8h0.2l6.7-40.8h8.9l-12,58.4h-7.4l-11.9-58.4H365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M437,188.1v7.9h-16.6v17.1h14.4v7.9h-14.4v17.1H437v8.4H412v-58.4H437z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M469,188.1l12.6,35.2h0.2v-35.2h8.4v58.4h-7.9l-12.8-35.1h-0.2v35.1h-8.4v-58.4H469z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M542.8,188.1v7.9h-9.7v50.5h-8.4V196H515v-7.9H542.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M592.1,233c0,8-6.2,13.9-14,13.9c-7.7,0-14-5.7-14-13.9v-31.5c0-8.1,6.2-13.9,14-13.9c7.7,0,14,5.7,14,13.9 V233z M572.4,232.9c0,3.6,2.5,5.7,5.7,5.7c3.2,0,5.7-2.1,5.7-5.7v-31.2c0-3.6-2.5-5.7-5.7-5.7c-3,0-5.6,2.1-5.6,5.7V232.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M661.1,188.1v58.4h-8.4v-58.4H661.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M695.8,188.1l12.6,35.2h0.2v-35.2h8.4v58.4H709l-12.8-35.1h-0.2v35.1h-8.4v-58.4H695.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M785.8,188.1v44.6c0,3.7,2.1,5.9,5.2,5.9c3.1,0,5.2-2.2,5.2-5.9v-44.6h8.4v45.5c0,7.4-6.1,13.4-13.5,13.4 c-7.2,0-13.5-6-13.5-13.4v-45.4H785.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M838.9,188.1l12.6,35.2h0.2v-35.2h8.4v58.4h-7.9l-12.8-35.1h-0.2v35.1h-8.4v-58.4H838.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M938.8,204.8v-2.3c0-5.3-3.2-6.6-5.2-6.6c-4.5,0-5.2,3.4-5.2,6.6v30.3c0,2.7,1.1,5.7,5.1,5.7 c1.6,0,5.2-0.7,5.2-6.2v-2.6h8.4v3.4c0,7.7-6,13.8-13.3,13.8c-8.6,0-13.8-5.2-13.8-13.4v-32.6c0-7.3,5.4-13.3,13.6-13.3 c4.2,0,7.5,1.7,9.7,4c2.3,2.5,3.8,5.3,3.8,10.7v2.5H938.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M981.2,188.1v50h16.6v8.4h-24.9v-58.4H981.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1030.6,188.1v58.4h-8.4v-58.4H1030.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1075.8,204.8v-2.3c0-5.3-3.2-6.6-5.2-6.6c-4.5,0-5.2,3.4-5.2,6.6v30.3c0,2.7,1.1,5.7,5.1,5.7 c1.6,0,5.2-0.7,5.2-6.2v-2.6h8.4v3.4c0,7.7-6,13.8-13.3,13.8c-8.6,0-13.8-5.2-13.8-13.4v-32.6c0-7.3,5.4-13.3,13.6-13.3 c4.2,0,7.5,1.7,9.7,4c2.3,2.5,3.8,5.3,3.8,10.7v2.5H1075.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1118.2,188.1v26.7h0.2l12.2-26.7h8.4l-11.4,23.4l13.5,35h-8.9l-9.5-25.9l-4.5,8.4v17.5h-8.4v-58.4H1118.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.0f9b78add9e18018ea0fa7e54fda7e7b.svg";
export { ForwardRef as ReactComponent };